import * as React from "react";
import { AppLayout } from "./AppLayout";
import { useTexts } from "../hooks/useTexts";
import { ContentContainer, Card } from "./common/StyledComponents";

export const WasserverbrauchSektorenRoute = React.memo(
  function WasserverbrauchSektorenRoute() {
    const { t } = useTexts();

    return (
      <AppLayout>
        <ContentContainer>
          <h1>
            {t(
              "wasserverbrauch.sektoren.title",
              "Wasserverbrauch nach Sektoren"
            )}
          </h1>

          <Card>
            <h2>
              {t(
                "wasserverbrauch.sektoren.aufteilung.title",
                "Aufteilung der öffentlichen Wasserversorgung"
              )}
            </h2>
            <p>
              {t(
                "wasserverbrauch.sektoren.aufteilung.intro",
                "Die öffentliche Wasserversorgung in Deutschland teilt sich auf verschiedene Sektoren auf:"
              )}
            </p>

            <h3>
              {t(
                "wasserverbrauch.sektoren.haushalte.title",
                "Private Haushalte (ca. 47%)"
              )}
            </h3>
            <ul>
              <li>
                {t(
                  "wasserverbrauch.sektoren.haushalte.item1",
                  "Trinkwasser und Kochen"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.haushalte.item2",
                  "Körperpflege und Hygiene"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.haushalte.item3",
                  "Toilettenspülung"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.haushalte.item4",
                  "Wäsche waschen"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.haushalte.item5",
                  "Geschirrspülen"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.haushalte.item6",
                  "Gartenbewässerung"
                )}
              </li>
            </ul>

            <h3>
              {t(
                "wasserverbrauch.sektoren.kleingewerbe.title",
                "Kleingewerbe (ca. 9%)"
              )}
            </h3>
            <ul>
              <li>
                {t(
                  "wasserverbrauch.sektoren.kleingewerbe.item1",
                  "Bürogebäude"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.kleingewerbe.item2",
                  "Einzelhandel"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.kleingewerbe.item3",
                  "Restaurants und Gaststätten"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.kleingewerbe.item4",
                  "Kleinbetriebe"
                )}
              </li>
            </ul>

            <h3>
              {t(
                "wasserverbrauch.sektoren.industrie.title",
                "Industrie (ca. 44%)"
              )}
            </h3>
            <ul>
              <li>
                {t(
                  "wasserverbrauch.sektoren.industrie.item1",
                  "Produktionsprozesse"
                )}
              </li>
              <li>
                {t("wasserverbrauch.sektoren.industrie.item2", "Kühlung")}
              </li>
              <li>
                {t("wasserverbrauch.sektoren.industrie.item3", "Reinigung")}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.industrie.item4",
                  "Dampferzeugung"
                )}
              </li>
            </ul>

            <h3>
              {t(
                "wasserverbrauch.sektoren.erkenntnisse.title",
                "Wichtige Erkenntnisse"
              )}
            </h3>
            <ul>
              <li>
                {t(
                  "wasserverbrauch.sektoren.erkenntnisse.item1",
                  "Private Haushalte sind der größte Einzelverbraucher"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.erkenntnisse.item2",
                  "Industrie und Haushalte verbrauchen zusammen über 90% des Wassers"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.erkenntnisse.item3",
                  "Unterschiedliche Qualitätsanforderungen je nach Verwendungszweck"
                )}
              </li>
              <li>
                {t(
                  "wasserverbrauch.sektoren.erkenntnisse.item4",
                  "Potenzial für Wassereinsparungen in allen Sektoren vorhanden"
                )}
              </li>
            </ul>
          </Card>
        </ContentContainer>
      </AppLayout>
    );
  }
);
